import { Autocomplete } from '@material-ui/lab'
import { Chip, styled, Typography } from 'opensolar-ui'

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  width: '100%',
  marginBottom: 16,
})

export const StyledAutocomplete = styled(Autocomplete)({
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    backgroundColor: '#fff',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976d2',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976d2',
      borderWidth: 2,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E0E0E0',
  },
  '& .MuiInputBase-input': {
    padding: '12px 14px !important',
  },
  '& .MuiAutocomplete-popupIndicator': {
    display: 'none',
  },
})

export const Description = styled(Typography)({
  fontSize: 12,
  marginTop: 2,
})

export const ChipsContainer = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
})

export const OptionItem = styled('div')({
  padding: '4px 0',
})

export const OptionName = styled('div')({
  fontWeight: 500,
  fontSize: 14,
})

export const OptionCode = styled('div')({
  fontSize: 12,
  color: '#6B6A76',
})
